<template>
  <div class="tools-partners-invites-received">
    <div class="row justify-content-between">
      <div class="d-flex align-items-center col-lg-6">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pagination.count"
      class="container centralize-row text-center pt-5"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.png"
          />
          <h5>Você ainda não recebeu convites</h5>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- desktop area -->
      <data-table
        new-design
        class="d-none d-lg-block"
        :columns="columns"
        :data="invitesReceived"
      >
        <template #default="{ item }">
          <small class="d-flex align-items-center">
            {{ item.company.name }}
          </small>
          <div>
            <span :class="statusBadge(item)">
              {{
                item.accepted_at
                  ? "Aprovado"
                  : item.rejected_at
                  ? "Rejeitado"
                  : "Pendente"
              }}
            </span>
          </div>
          <div class="d-flex align-items-center justify-content-end">
            <actions-dropdown
              v-if="!item.accepted_at && !item.rejected_at"
              :left="false"
              :right="true"
              :actions="actions"
              @accept="accept(item)"
              @reject="reject(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of desktop -->
      <!-- mobile area -->
      <data-table
        new-design
        class="d-lg-none"
        :columns="['', '']"
        :data="invitesReceived"
      >
        <template #default="{ item }">
          <div class="d-flex flex-column py-5 responsive-table">
            <span>
              <strong>Empresa: </strong>
              {{ item.company.name }}
            </span>
            <span>
              <strong>Status: </strong>
              <span :class="statusBadge(item)">
                {{
                  item.accepted_at
                    ? "Aprovado"
                    : item.rejected_at
                    ? "Rejeitado"
                    : "Pendente"
                }}
              </span>
            </span>
          </div>
          <div class="d-flex justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions"
              @accept="accept(item)"
              @reject="reject(item)"
            />
          </div>
        </template>
      </data-table>
      <!-- end of mobile -->
      <div class="mt-5 d-flex justify-content-end">
        <paginator
          v-show="invitesReceived.length && !loading"
          :pagination="pagination"
          @on-update="dispatch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      actions: [
        {
          text: "Aceitar",
          class: "text-success",
          icon: "fa-solid fa-check",
          confirmation: {
            enable: true,
            newDesign: true,
            submitButtonClass: "btn-success",
            text: "Tem certeza de que deseja aceitar o convite?"
          },
          event: "accept"
        },
        {
          text: "Rejeitar",
          class: "text-danger",
          icon: "fa-solid fa-close",
          confirmation: {
            enable: true,
            newDesign: true,
            submitButtonClass: "btn-danger",
            text: "Tem certeza de que deseja rejeitar o convite?"
          },
          event: "reject"
        }
      ],
      columns: ["Empresa", "Status", ""],
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["invitesReceived"])
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    status(item) {
      if (item.accepted_at)
        return "<strong class='text-success'>APROVADO</strong>";
      if (item.rejected_at)
        return "<strong class='text-danger'>REJEITADO</strong>";
      return "<strong class='text-secondary'>PENDENTE</strong>";
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getMyInvites", { offset })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    statusBadge(item) {
      if (item.accepted_at) return "active-badge";
      if (item.rejected_at) return "inactive-badge";
      return "draft-badge";
    },
    accept(item) {
      this.update(item.code, true);
    },
    reject(item) {
      this.update(item.code, false);
    },
    update(code, to_accept) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/putMyInvite", { code, to_accept })
        .then(() => {
          this.dispatch();
          this.$store.dispatch("postLogin");
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
